/**
 * State acts as a pool of states (it is a iife/singleton):
 * - empty     the document to render is empty
 * - updating  the document to render is currently updating
 * - loaded    the document to render is fully loaded
 *
 * Then each document is responsible of updating its own state by
 * picking a state from this pool.
 *
 * __Usage__:
 *
 * document.state(state.loaded);
 * document.renderDocumentOn(html){
 *     document.state.renderDocumentOn(document, html);
 * }
 */

export default (function () {
	const that = {};

	that.loaded = {
		renderTitleOn: function (document, html) {
			document.renderTitleOn(html);
		},
		renderDocumentOn: function (document, html) {
			document.renderContentOn(html);
		},
		renderActionsOn: function (document, html) {
			document.renderActionsOn(html);
		},
		label: "default",
	};

	that.empty = {
		renderTitleOn: function (document, html) {
			document.renderEmptyTitleOn(html);
		},
		renderDocumentOn: function (document, html) {
			document.renderEmptyContentOn(html);
		},
		renderActionsOn: function (document, html) {
			document.renderEmptyActionsOn(html);
		},
		label: "empty",
	};

	that.updating = {
		renderTitleOn: function (document, html) {
			document.renderUpdatingTitleOn(html);
		},
		renderDocumentOn: function (document, html) {
			document.renderUpdatingContentOn(html);
		},
		renderActionsOn: function (document, html) {
			document.renderUpdatingActionsOn(html);
		},
		label: "updating",
	};

	that.allStates = [that.loaded, that.empty, that.updating];

	return that;
})();
